import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useAuthStore from '../lib/auth-store';

export default function DemoVerifyPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { demoVerify } = useAuthStore();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setErrorMsg('No verification token found. Please request a new demo link.');
      return;
    }

    demoVerify(token).then((ok) => {
      if (ok) {
        setStatus('success');
        setTimeout(() => navigate('/'), 1200);
      } else {
        setStatus('error');
        setErrorMsg('This link has expired or already been used. Please request a new demo.');
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg,#1e1b4b 0%,#312e81 100%)' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: '48px 40px', maxWidth: 420, width: '90%', textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>
        <img src="/isocntrl-logo-400.png" alt="ISOCNTRL" style={{ height: 48, margin: '0 auto 24px', display: 'block' }} />

        {status === 'verifying' && (
          <>
            <div style={{ width: 48, height: 48, borderRadius: '50%', border: '3px solid #e5e7eb', borderTopColor: '#4f46e5', animation: 'spin 0.8s linear infinite', margin: '0 auto 20px' }} />
            <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1e1b4b', margin: '0 0 8px' }}>Verifying your email…</h2>
            <p style={{ color: '#6b7280', fontSize: 14 }}>Just a moment, setting up your demo.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#ecfdf5', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
              <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="#10b981" strokeWidth="2.5"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
            </div>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1e1b4b', margin: '0 0 8px' }}>You're in!</h2>
            <p style={{ color: '#6b7280', fontSize: 14 }}>Email confirmed. Loading your personalized demo…</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#fef2f2', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
              <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="#ef4444" strokeWidth="2.5"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
            </div>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1e1b4b', margin: '0 0 8px' }}>Link expired</h2>
            <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 24 }}>{errorMsg}</p>
            <button
              onClick={() => navigate('/login')}
              style={{ background: '#4f46e5', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 28px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
            >
              Back to Login
            </button>
          </>
        )}
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
